import { Component, Input } from '@angular/core';

export interface ITooltip {
    ids: string[];
    toolTip: string;
}

@Component(
    {
    selector: 'cz-tooltips',
    templateUrl: './tooltips.component.html',
    styleUrls: ['./tooltips.component.css'],
    standalone: false
})

export class TooltipsComponent {

    @Input() toolTips: ITooltip[];

    constructor() {
    }

}
